export default "/images/917de68d7806e7f5669f6f517050e518.avif";